module.exports = __webpack_public_path__ + "static/media/rital.eeceb6da.png";